import {types} from "mobx-state-tree";

export const SolarSelectionModel = types.model( 'SolarSelectionModel', {
    roofMaterial: types.maybeNull( types.string ),
    roofOrientation: types.maybeNull( types.string ),
    roofWidth: types.maybeNull( types.number ),
    roofLength: types.maybeNull( types.number ),
    roofSlope: types.maybeNull( types.number ),
    roofSurface: types.maybeNull( types.number ), // roofHeight: types.maybeNull(types.number),
} )
    .views( self => ({}) )
    .actions( self => ({
        recalculateRoofSurface()
        {
            if ( self.roofWidth && self.roofLength ) {
                self.roofSurface = self.roofWidth * self.roofLength;
            }
            else {
                self.roofSurface = null;
            }
        },
        reset()
        {
            self.roofMaterial = null;
            self.roofOrientation = null;
            self.roofWidth = null;
            self.roofLength = null;
            self.roofSlope = null;
            self.roofSurface = null;
        }
    }) )
    .actions( self => ({
        setRoofMaterial( roofMaterial: string )
        {
            self.roofMaterial = roofMaterial;
        },
        setRoofOrientation( roofOrientation: string )
        {
            self.roofOrientation = roofOrientation;
        },
        setRoofWidth( width: number | null )
        {
            if ( !width || isNaN( width ) ) {
                self.roofWidth = null;
            }
            else {
                self.roofWidth = width;
            }
            self.recalculateRoofSurface();
        },
        setRoofLength( length: number | null )
        {
            if ( !length || isNaN( length ) ) {
                self.roofLength = null;
            }
            else {
                self.roofLength = length;
            }
            self.recalculateRoofSurface();
        },
        setRoofSlope( slope: number )
        {
            const wasAngledButNowFlat = slope == 1 && self.roofSlope != 1;
            const wasFlatButNowAngled = slope != 1 && self.roofSlope == 1;
            if ( wasAngledButNowFlat || wasFlatButNowAngled ) {
                self.roofLength = null;
            }
            self.roofSlope = slope;
            self.recalculateRoofSurface();
        }
    }) );
